var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content mb-6 lg:w-11/12"},[_c('div',{staticClass:"map-container",attrs:{"id":"map"}})])}]

export { render, staticRenderFns }